<template>
    <div class="elder">
        <mt-header fixed title="老人详情">
            <router-link to="/community" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-detail">
            <mt-cell title="姓名" :value="elder.name"></mt-cell>
            <mt-cell title="信息饱和度" :value="elder.total_complete_rate+'%'"></mt-cell>
            <mt-cell title="所属服务点" :value="elder.station_name"></mt-cell>
            <mt-cell title="证件类型" :value="elder.id_type"></mt-cell>
            <mt-cell title="证件号码" :value="elder.id_number"></mt-cell>

            <mt-cell title="老人分类" :value="elder.elder_type"></mt-cell>
            <mt-cell title="政府补偿" :value="elder.allowance"></mt-cell>
            <mt-cell title="居住情况" :value="elder.live_status"></mt-cell>

            <mt-cell title="性别" :value="elder.sex"></mt-cell>
            <mt-cell title="民族" :value="elder.nation"></mt-cell>
            <mt-cell title="出生日期" :value="elder.birthday"></mt-cell>
            <mt-cell title="年龄" :value="elder.age"></mt-cell>
            <mt-cell title="婚姻状况" :value="elder.marriage"></mt-cell>

            <mt-cell title="户籍地址" :value="elder.province_name+elder.city_name+elder.country_name+elder.town_name+elder.village_name+elder.address"></mt-cell>
            <mt-cell title="居住地址" :value="elder.live_province_name+elder.live_city_name+elder.live_country_name+elder.live_town_name+elder.live_village_name+elder.live_address"></mt-cell>

            <mt-cell title="联系电话" :value="elder.phone"></mt-cell>
            <mt-cell title="其他联系电话" :value="elder.other_phone"></mt-cell>

            <mt-cell title="状态" :value="elder.status_name"></mt-cell>
        </div>
    </div>
</template>
<style>

    .elder-detail{
        padding-top:50px;
    }

    .elder-detail .mint-cell-value{
        width: 70%;
    }
</style>
<script>
    export default{
        data(){
            return {
                elder: '',
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id
            }
        },

        created(){
            this.$indicator.open('加载中');

            this.$axios.post("/elder/detail/"+this.id, {openid:this.openid})
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.elder = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });

        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/elderDetail.vue